import BillingsTaxiTaxiEditRequest, {
  BillingsTaxiTaxiEditRequestBody,
} from "./billings-taxi-taxi-edit.request";

const createBody = (
  request: BillingsTaxiTaxiEditRequest,
): BillingsTaxiTaxiEditRequestBody => {
  return {
    billingContributions: request.billingContributions,
    billingNodes: request.billingNodes,
  };
};

const billingsTaxiTaxiEditRequestFactory = {
  createBody,
};

export default billingsTaxiTaxiEditRequestFactory;
